import { S } from '../app/app_state.js?v=20260817c';
import { state } from '../registry/system_registry_core.js?v=20260904f';

const pending = new Map();
let installed = false;
let editing = null;
let pressed = false;
let timer = null;
const context = () => [S.project, S.drawingSheets?.activeSheetId, state.activeSystemId,
  JSON.stringify(S.selection || {}), Boolean(S.ui?.showAppOptions), Boolean(S.ui?.showAppAdminPanel)];
const sameContext = (a, b) => a.every((value, index) => value === b[index]);
function editable(element) {
  if (!element?.closest?.('.topbar, .statusbar, .sidebar, #floorplanStatusControls')) return false;
  if (element.isContentEditable || element.tagName === 'TEXTAREA') return true;
  return element.tagName === 'INPUT' && !['button', 'submit', 'reset', 'checkbox', 'radio', 'range', 'color', 'file', 'hidden'].includes(element.type);
}
function blocked() {
  const active = document.activeElement;
  if (!editable(active)) return false;
  if (!editing || editing.element !== active) editing = { element: active, context: context() };
  return sameContext(editing.context, context());
}
function flushSoon() {
  if (timer !== null) return;
  timer = setTimeout(() => {
    timer = null;
    if (pressed || blocked()) return;
    const work = [...pending.values()];
    pending.clear();
    for (const render of work) render();
  }, 0);
}
function install() {
  if (installed) return;
  installed = true;
  document.addEventListener('focusin', event => {
    editing = editable(event.target) ? { element: event.target, context: context() } : null;
  }, true);
  document.addEventListener('focusout', flushSoon, true);
  // Blur occurs during pointerdown, before the eventual click. Keep that
  // click's DOM target alive until its action has finished (also on touch).
  document.addEventListener('pointerdown', () => { pressed = true; }, true);
  document.addEventListener('pointerup', () => { pressed = false; flushSoon(); }, true);
  document.addEventListener('pointercancel', () => { pressed = false; flushSoon(); }, true);
  globalThis.window?.addEventListener?.('blur', () => { pressed = false; });
}

/** Defer only replaceable shell UI. Model commits and plan rendering keep running.
 * Callbacks read current state; never capture an old project or input value.
 */
export function deferShellRender(key, render) {
  if (typeof document === 'undefined' || typeof document.addEventListener !== 'function') return false;
  install();
  if (blocked() || pressed && pending.size > 0) {
    pending.set(key, render);
    return true;
  }
  pending.delete(key);
  return false;
}
